import PropTypes from "prop-types";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { resolveUploadUrl } from "utils";

function GallerySection({ items, loading }) {
  return (
    <MDBox id="galeri" component="section" py={8}>
      <Container>
        <MDBox textAlign="center" mb={5}>
          <MDTypography variant="h3" fontWeight="bold" mb={1}>
            Galeri Aktivitas Dinas
          </MDTypography>
          <MDTypography variant="body2" color="text" maxWidth="42rem" mx="auto">
            Dokumentasi kegiatan dan pelayanan terbaru DPMPTSP Kabupaten Rote Ndao (maks. 9 foto terkini).
          </MDTypography>
        </MDBox>

        {loading ? (
          <MDTypography textAlign="center" color="text">
            Memuat galeri...
          </MDTypography>
        ) : items.length === 0 ? (
          <MDTypography textAlign="center" color="text">
            Belum ada foto aktivitas yang ditampilkan.
          </MDTypography>
        ) : (
          <Grid container spacing={3}>
            {items.map((item) => (
              <Grid item xs={12} sm={6} md={4} key={item.id}>
                <Card sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
                  <CardMedia
                    component="img"
                    height="220"
                    image={resolveUploadUrl(item.file_url)}
                    alt={item.caption}
                    sx={{ objectFit: "cover" }}
                  />
                  <CardContent sx={{ flexGrow: 1 }}>
                    <MDTypography variant="button" color="text" fontWeight="regular">
                      {item.caption}
                    </MDTypography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}
      </Container>
    </MDBox>
  );
}

GallerySection.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      caption: PropTypes.string.isRequired,
      file_url: PropTypes.string,
    })
  ).isRequired,
  loading: PropTypes.bool.isRequired,
};

export default GallerySection;
